"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility class to manipulates and alter arrays.
 */
ngModule.factory("arrayUtils", function () {
  return {
    /**
     * Returns true if array contains any of given items, false otherwise.
     * @param array
     * @param items
     */
    containsAny: function containsAny(array, items) {
      for (var i = 0; i < items.length; i++) {
        if (_.includes(array, items[i])) {
          return true;
        }
      }
      return false;
    },
    /**
     * Clear the destination array, then fill it with elements from the source array.
     * Used to replace array while keeping it's reference.
     *
     * @param destination
     * @param source
     */
    fillWith: function fillWith(destination, source) {
      destination.splice(0, destination.length);
      destination.push.apply(destination, source);
    },
    /**
     * Remove all elements from given array
     * 
     * @param array
     */
    clearArray: function clearArray(array) {
      array.splice(0, array.length);
    },
    /**
     * Move an element in given `array` from `fromIndex` position to `toIndex` position.
     *
     * @param array
     * @param fromIndex
     * @param toIndex
     */
    moveElement: function moveElement(array, fromIndex, toIndex) {
      if (fromIndex < 0 || toIndex < 0 || fromIndex >= array.length || toIndex >= array.length) {
        return;
      }
      array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    },
    /**
     * Delete element at 'index' from given `array`
     *
     * @param array
     * @param index
     */
    deleteElement: function deleteElement(array, index) {
      if (index < 0 || index >= array.length) {
        return;
      }
      array.splice(index, 1);
    },
    /**
     * Insert given element at 'index' in given `array`
     *
     * @param array
     * @param index
     * @param element
     */
    insertElement: function insertElement(array, index, element) {
      if (index < 0 || index > array.length) {
        return;
      }
      array.splice(index, 0, element);
      return array;
    },
    /**
     * Swap given elements in given array
     *
     * @param array The array to swap in
     * @param firstIndex Index of the first element
     * @param secondIndex Index of the second element
     */
    swapElements: function swapElements(array, firstIndex, secondIndex) {
      var tmp = array[firstIndex];
      array[firstIndex] = array[secondIndex];
      array[secondIndex] = tmp;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/arrayUtils.js
// module id = 2744
// module chunks = 13